// Sidebar nav definition. Exported so CoreMonit can merge it in.

import type { ComponentType, SVGProps } from "react";
import {
  LayoutDashboard, Boxes, GitBranch, ContainerIcon, Network, ListTree, Terminal,
  Activity, AlertTriangle, GitFork, HeartPulse, Bot, Bell, Shield, Flame,
  Beaker, DownloadCloud, Sparkles, FolderKanban, LayoutGrid, Server,
} from "lucide-react";

export interface NavItem {
  id: string;
  label: string;
  path: string;
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  badge?: string;
  badgeColor?: "blue" | "green" | "amber" | "red" | "purple" | "cyan";
  group: "monitor" | "explore" | "investigate" | "operate";
}

export const MICROSERVICES_NAV: NavItem[] = [
  { id: "overview",     label: "Overview",           path: "/",             icon: LayoutDashboard, group: "monitor" },
  { id: "projects",     label: "Projects",           path: "/projects",     icon: FolderKanban,    group: "monitor" },
  { id: "services",     label: "Services",           path: "/services",     icon: Boxes,           group: "monitor", badge: "20", badgeColor: "blue" },
  { id: "deployments",  label: "Deployments",        path: "/deployments",  icon: GitBranch,       group: "monitor" },
  { id: "containers",   label: "Container Explorer", path: "/containers",   icon: ContainerIcon,   group: "monitor" },
  { id: "workspace",    label: "Ops Workspace",      path: "/workspace",    icon: LayoutGrid,      group: "monitor" },
  { id: "clusters",     label: "Clusters",           path: "/clusters/prod-eks-01", icon: Server,   group: "monitor" },
  { id: "map",          label: "Service Map",        path: "/map",          icon: Network,         group: "explore" },
  { id: "traces",       label: "Distributed Tracing",path: "/traces",       icon: ListTree,        group: "explore" },
  { id: "logs",         label: "Log Explorer",       path: "/logs",         icon: Terminal,        group: "explore" },
  { id: "metrics",      label: "Metrics",            path: "/metrics",      icon: Activity,        group: "explore" },
  { id: "rca",          label: "Root Cause Analysis",path: "/rca",          icon: AlertTriangle,   group: "investigate", badge: "AI", badgeColor: "purple" },
  { id: "dependencies", label: "Dependency Analysis",path: "/dependencies", icon: GitFork,         group: "investigate" },
  { id: "health",       label: "Service Health",     path: "/health",       icon: HeartPulse,      group: "investigate" },
  { id: "ai",           label: "AI Assistant",       path: "/ai",           icon: Bot,             group: "investigate", badge: "AI", badgeColor: "purple" },
  { id: "alerts",       label: "Alerting",           path: "/alerts",       icon: Bell,            group: "operate" },
  { id: "security",     label: "Security",           path: "/security",     icon: Shield,          group: "operate" },
  { id: "profiling",    label: "Performance Profiling", path: "/profiling", icon: Flame,           group: "operate" },
  { id: "testing",      label: "Testing Center",     path: "/testing",      icon: Beaker,          group: "operate" },
  { id: "export",       label: "Export",             path: "/export",       icon: DownloadCloud,   group: "operate" },
];

export const GROUP_LABEL: Record<NavItem["group"], string> = {
  monitor:     "Monitor",
  explore:     "Explore",
  investigate: "Investigate",
  operate:     "Operate",
};
